module.exports = __webpack_public_path__ + "static/media/eq_pg_success.47410fad.svg";